import React, { type ReactNode } from 'react'
import { cn } from '~/shadcn/lib/utils'
import { RadioGroup, RadioGroupItem } from './radio-group'
import { Label } from './label'

type Props = Omit<
  React.ComponentProps<typeof RadioGroup>,
  'value' | 'onValueChange'
> & {
  labelYes?: ReactNode
  labelNo?: ReactNode
  value?: boolean
  onValueChange(value: boolean): void
}

export function YesNoRadioGroup({
  value,
  labelYes,
  labelNo,
  onValueChange,
  className,
  ...props
}: Props) {
  const yesId = React.useId()
  const noId = React.useId()

  const getValue = () => {
    if (value === undefined) {
      return ''
    }
    return value ? 'yes' : 'no'
  }

  return (
    <RadioGroup
      {...props}
      className={cn('gap-4', className)}
      value={getValue()}
      onValueChange={(val) => {
        onValueChange(val === 'yes')
      }}>
      <div className="flex items-center gap-2">
        <Label htmlFor={yesId} className="text-base cursor-pointer">
          <RadioGroupItem value="yes" id={yesId} />
          {labelYes ?? 'Áno'}
        </Label>
      </div>
      <div className="flex items-center gap-2">
        <Label htmlFor={noId} className="text-base cursor-pointer">
          <RadioGroupItem value="no" id={noId} />
          {labelNo ?? 'Nie'}
        </Label>
      </div>
    </RadioGroup>
  )
}
